import { Avatar, Box, Card, Grid, Typography } from "@material-ui/core";
import React, { Component, Fragment } from "react";
import { extractSignature, extractAiFlags } from "../../store/form.answer.extract";
import { withStyles } from "@material-ui/styles";
import ImagePopup from "./ImagePopup";
import { AiStatusOverlay } from "../../../components/AiStatusOverlay";

const styles = (theme) => ({
  root: {
    padding: theme.spacing(1),
    marginTop: 0,
  },
});

export class Signature extends Component {
  constructor(props) {
    super(props);
    this.state = {
      signature: "",
      name: "",
      imageSignatureOpen: false,
      imageOpen: false,
      // helpTextValue: "",
      imageValue: [],
      imageUrl: "",
      imageName: "",
      isSignature: true,
      aiFlags: {},
    };
  }

  async componentDidMount() {
    this.onLoadPage(this.props);
    if (this.props.element.properties.allowFileUpload) {
      this.onLoadImage(this.props);
    }
    // if (this.props.element.properties.answerLabel) {
    //   this.onLoadHelpText(this.props);
    // }
  }

  async onLoadPage(props) {
    if (props.element) {
      let answer = props.element.answer;
      let userResponse = await extractSignature(answer);
      if (userResponse) {
        let signature = userResponse.signature;
        if (signature) {
          this.setState({ signature: signature });
        }
        let name = userResponse.name;
        if (name) {
          this.setState({ name: name });
        }
      }
    }
  }

  // onLoadHelpText(props) {
  //   const answerLabel = props.element.properties.answerLabel;
  //   if (answerLabel) {
  //     this.setState({ helpTextValue: answerLabel });
  //   }
  // }

  onLoadImage(props) {
    if (props.element && props.element.answer) {
      let image = props.element?.answer[0]?.images;
      if (image) {
        this.setState({ imageValue: image });
      }
      this.setState({ aiFlags: extractAiFlags(props.element.answer) });
    }
  }

  onClickAvatar = (image) => {
    this.setState({
      imageOpen: true,
      imageUrl: image.imageUrl,
      imageName: image.imageName,
    });
  };

  onClickSignature = () => {
    this.setState({
      imageSignatureOpen: true,
    });
  };

  onCloseSignature = () => {
    this.setState({ imageSignatureOpen: false });
  };

  onClose = () => {
    this.setState({ imageOpen: false });
  };

  render() {
    const { classes } = this.props;
    let signature;
    if (this.state.signature !== null && this.state.signature.length > 0) {
      signature = (
        <Avatar
          alt={this.state.name}
          src={this.state.signature}
          variant="square"
          style={{ height: "75px", width: "100px" }}
          onClick={this.onClickSignature}
        />
      );
    }
    return (
      <Fragment>
        <Typography className={classes.userResponseFont}>
          {signature}
        </Typography>
        <ImagePopup
          open={this.state.imageSignatureOpen}
          onClose={this.onCloseSignature}
          imageUrl={this.state.signature}
          title={this.state.name}
          isSignature={this.state.isSignature}
        ></ImagePopup>
        {this.props.element.properties.allowFileUpload &&
          this.state.imageValue.length > 0 && (
            <Card className={classes.root}>
              <Box>
                <Grid container spacing={1}>
                  <AiStatusOverlay
                    imageList={this.state.imageValue}
                    aiVerificationStatus={this.state.aiFlags.aiVerificationStatus}
                    aiVerificationMessage={this.state.aiFlags.aiVerificationMessage}
                  />
                </Grid>
              </Box>
            </Card>
          )}
        <ImagePopup
          open={this.state.imageOpen}
          onClose={this.onClose}
          imageUrl={this.state.imageUrl}
          title={this.state.imageName}
        ></ImagePopup>
        {/* {this?.state?.helpTextValue && (
          <FormHelperText>{this.state.helpTextValue}</FormHelperText>
        )} */}
      </Fragment>
    );
  }
}

export default withStyles(styles)(Signature);
